import { Grid, Switch, styled } from "@mui/material";
import { Stack } from "@mui/system";

import { SubHeader } from "../Typography/SubHeader/SubHeader";
import { Text } from "../Typography/Text/Text";

export const Toggle = ({ header, text, defaultChecked, disabled }) => {
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      disabled={disabled}
      defaultChecked={defaultChecked}
      {...props}
    />
  ))(({ theme }) => ({
    width: "32px", // setting outer box size
    height: "16px",
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#65C466", // sets outter box color on checked color change considering the dark mode
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600], // outer box on unchecked color change considering the dark mode
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box", // this is the middle round icon AKA thump
      width: "12px",
      height: "12px",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));
  return (
    <>
      <SubHeader text={header} />
      <Stack direction={"row"} spacing={0.87}>
        <Text text={text} />
        <IOSSwitch />
      </Stack>
    </>
  );
};
